module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      },
      "title": "Início"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Início")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/estoque'
      },
      "title": "Estoque"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-list-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Estoque")])])], 1), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-entries') || _vm.profile.map.hasOwnProperty('checklist-items') || _vm.profile.map.hasOwnProperty('expense-types')) ? _c('li', [_vm._m(0), _vm._v(" "), _c('ul', [(_vm.profile.map.hasOwnProperty('vehicle-entries')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-entry'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-in"
  }), _vm._v(" Entrada de veículos\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-sale')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-sale',
        query: {
          'verified': 'unverified',
          't': 'Negociações'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Negociações\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-sale')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-sale',
        query: {
          'verified': 'verified',
          't': 'Saídas'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Saídas\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('checklist-items')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/checklist-items'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square-o"
  }), _vm._v(" Itens do checklist\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('expense-types')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/expense-types'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-window-restore"
  }), _vm._v(" Tipos de despesas\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('expense-types')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/payment-method'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-credit-card"
  }), _vm._v(" Tipos de Pagamento\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('categories-pendency')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/categories-pendency'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag"
  }), _vm._v(" Categorias de Pendência\n          ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/expense-vehicle-plate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-car"
  }), _vm._v(" Despesa de veículo\n          ")])], 1), _vm._v(" "), _c('li', [(_vm.profile.map.hasOwnProperty('general-expenses')) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/expenses'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-refresh"
  }), _vm._v(" Despesas Gerais\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(_vm.profile.map.hasOwnProperty('account-mov')) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/receive'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-in"
  }), _vm._v(" A Receber\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(_vm.profile.map.hasOwnProperty('account-mov')) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/pay'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" A Pagar\n          ")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.profile.map.hasOwnProperty('customers')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/customers'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-group"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Pessoas")])])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('employees')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/employees'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v(" Funcionários")])])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('finantial')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/finantial'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-institution"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v(" Financeiras ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('account-mov') || _vm.profile.map.hasOwnProperty('card-operators') || _vm.profile.map.hasOwnProperty('account-plans') || _vm.profile.map.hasOwnProperty('account-types')) ? _c('li', [_vm._m(2), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/nfe'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-archive"
  }), _vm._v(" Notas Fiscais\n          ")])], 1), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-sale')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-sale',
        query: {
          'verified': 'unverified',
          't': 'Negociações'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Negociações\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-sale')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-sale',
        query: {
          'verified': 'verified',
          't': 'Saídas'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Saídas\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('account-mov')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/account-mov'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exchange"
  }), _vm._v(" Contas de Mov.\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('card-operators')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/card-operators'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-credit-card"
  }), _vm._v(" Operadoras Cartão\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('account-plans')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/account-plans'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list"
  }), _vm._v(" Planos de contas\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('account-types')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/account-mov-type'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag"
  }), _vm._v(" Tipos de Conta\n          ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('profiles')) ? _c('li', [_c('router-link', {
    attrs: {
      "href": "#",
      "to": {
        path: '/profiles'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-tags"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Perfis")])])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('tenants')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tenants'
      },
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-building"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Unidades")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/reports'
      },
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Relatórios")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/reports-v2'
      },
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Relatórios v2")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/configurations'
      },
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Configurações")])])], 1), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-car"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Veículos ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-money"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Entrada / Saída ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-dollar"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Financeiro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://webmail-seguro.com.br/vipcarseminovos.com.br/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-at"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Email")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f48b820"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavLeft.vue
// module id = 985
// module chunks = 1